<template>
    <div class="app-container">
        <div class="page flex-col">
            <div class="image-wrapper_1 flex-row justify-between">
                <img class="image_1" referrerpolicy="no-referrer" src="@/assets/img/home/mb1.png" />
                <img class="thumbnail_1" referrerpolicy="no-referrer" @click="isShow = !isShow" v-show="!isShow" src="@/assets/img/home/mb2.png" />
                <img class="thumbnail_1" referrerpolicy="no-referrer" @click="isShow = !isShow" v-show="isShow" src="@/assets/img/home/mb3.png" />

            </div>
            <div class="section_3 flex-col" v-show="isShow">
                <div class="block_4 flex-row justify-between" v-for="item in menuList" :key="item.id" @click="routerLink(item.path)">
                    <span class="text_25">{{ item.name }}</span>
                    <img class="thumbnail_14" referrerpolicy="no-referrer" src="@/assets/img/home/mb4.png" />
                </div>
            </div>
            <router-view />
            <MobileFooter></MobileFooter>
        </div>
    </div>
</template>


<script>

import { listMenu } from "@/api/web";
import MobileFooter from "@/components/MobileFooter";
export default {
    name: "mbhome",
    components: {
        MobileFooter
    },
    data() {
        return {
            isShow: false,
            menuList: [],
            queryParams: {
                mobile: true,
            }
        };
    },
    created() {
        this.getList();
    },
    mounted() {

    },
    methods: {
        getList() {
            listMenu(this.queryParams).then(response => {
                this.menuList = response.rows;
            })
        },
        routerLink(path) {
            this.$router.push({
                path: path
            })
            this.isShow = false;
        },
    }
}
</script>
<style lang="scss" src="@/assets/css/mobile/common.css" />
<style lang="scss" scoped src="@/assets/css/mobile/home.css" />
<style>
/* 以下代码是为了解决移动端页面缩放问题 */
@media only screen and (max-width: 390px) {
    body {
        zoom: 90%;
    }
}
</style>


// WEBPACK FOOTER //
// src/views/mobile/mbhome.vue